var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:{ 'is-not-zh': !_vm.$i18n.locale.includes('zh') },attrs:{"id":"app"}},[(_vm.isViewAlive)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }